import './styles.css';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import closeAgeVerificationIcon from './close-age-ver.svg';

const AgeVerificationPopup = ({ onConfirm, onClose }) => {
  const [ageChecked, setAgeChecked] = useState(false);

  useEffect(() => {
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;
    const previousBodyPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
      document.body.style.paddingRight = previousBodyPaddingRight;
    };
  }, []);

  const handleOverlayClick = (event) => {
    event.stopPropagation();
    onClose();
  };

  const stopPopupClick = (event) => {
    event.stopPropagation();
  };

  const handleClose = (event) => {
    event.stopPropagation();
    onClose();
  };

  const handleConfirm = () => {
    if (!ageChecked) {
      return;
    }

    onConfirm();
  };

  const popup = (
    <div className="age-popup-overlay" onClick={handleOverlayClick}>
      <div className="age-popup" onClick={stopPopupClick}>
        <button className="age-popup-close" type="button" aria-label="Close age verification" onClick={handleClose}>
          <img src={closeAgeVerificationIcon} alt="" />
        </button>
        <div className="age-popup-top">
          <h2>Before you enter</h2>
          <p>
            We only allow participants who are 18+. Please check the box to confirm that you are — we'll do a quick
            check in the background.
          </p>
        </div>
        <div className="age-popup-buttons">
          <label className="age-checkbox">
            <input type="checkbox" checked={ageChecked} onChange={(e) => setAgeChecked(e.target.checked)} />
            <span>I'm 18 or older and agree to age verification</span>
          </label>

          <button type="button" className="age-popup-continue" disabled={!ageChecked} onClick={handleConfirm}>
            <p>Continue</p>
          </button>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') {
    return popup;
  }

  return ReactDOM.createPortal(popup, document.body);
};

export default AgeVerificationPopup;
